// assets
import {
  ChromeOutlined,
  QuestionOutlined,
  ContainerOutlined,
  DownOutlined,
  UserOutlined,
  UserSwitchOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { IoSettings } from "react-icons/io5";

// icons
const icons = {
  ChromeOutlined,
  QuestionOutlined,
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const Reports = {
  id: "Settings",
  title: "Admin",
  type: "group",
  children: [
    {
      id: "Settings",
      title: "Settings",
      type: "collapse",
      url: "/Settings",
      icon: IoSettings,
      children: [
        // {
        //   id: "Settings",
        //   title: "Users",
        //   type: "item",
        //   url: "/settings/users",
        //   icon: UserAddOutlined,
        // },
        {
          id: "Settings",
          title: "User Roles",
          type: "item",
          url: "/settings/userroles",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
          title: "User Designation",
          type: "item",
          url: "/settings/userdesignation",
          icon: UserSwitchOutlined,
        },
        // {
        //   id: "Settings",
        //   title: "User Designation",
        //   type: "item",
        //   url: "/settings/userdesignation",
        //   icon: UserSwitchOutlined,
        // },
        {
          id: "Settings",
          title: "User Organization",
          type: "item",
          url: "/settings/userorganization",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
          title: "User Region",
          type: "item",
          url: "/settings/useRegion",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
          title: "User Role Mapping",
          type: "item",
          url: "/settings/userrolemapping",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
		  title: "Case Tab Mapping",
          type: "item",
          url: "/settings/caseTabMapping",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",			 
          title: "Case Checklist",
          type: "item",
          url: "/settings/caseChecklist",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
          title: "Case Template",
          type: "item",
          url: "/settings/caseTemplate",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
          title: "Report Builder",
          type: "item",
          url: "/settings/reportBuilder",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
          title: "Notice Template Builder",
          type: "item",
          url: "/settings/noticeTemplateTable",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
          title: "Create Notice Template",
          type: "",
          url: "/settings/noticeTemplate/create",
          icon: UserSwitchOutlined,
          parant: "Notice Template Builder",
          parantUrl: "/settings/noticeTemplateTable",
          breadcrumbs: true,
        },
        {
          id: "Settings",
          title: "Edit Notice Template",
          type: "",
          url: "/settings/noticeTemplate/edit/:Id",
          icon: UserSwitchOutlined,
          parant: "Notice Template Builder",
          parantUrl: "/settings/noticeTemplateTable",
          breadcrumbs: true,
        },
        {
          id: "Settings",
          title: "PDF Document",
          type: "item",
          url: "/settings/pdfdocument",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
          title: "Case Tags",
          type: "item",
          url: "/settings/caseTags",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
          title: "Case Mapping",
          type: "item",
          url: "/settings/caseMapping",
          icon: UserSwitchOutlined,
        },
        {
          id: "Settings",
          title: "Communication",
          type: "item",
          url: "/settings/communication",
          icon: UserSwitchOutlined,
        },

        {
          id: "Settings",
          title: "Create Communication",
          type: "",
          url: "/settings/communication/create",
          breadcrumbs: true,
          parant: "Communication",
          parantUrl: "/settings/communication",
        },
        {
          id: "Settings",
          title: "Edit Communication",
          type: "",
          url: "/settings/communication/edit/:Id",
          breadcrumbs: true,
          parant: "Communication",
          parantUrl: "/settings/communication",
        },
         {
          id: "Settings",
          title: "Audit Trails",
          type: "item",
          url: "/settings/commAuditTrails",
          icon: UserSwitchOutlined,
          breadcrumbs: true,
        },
         {
          id: "Settings",
          title: 'Spfx',
          type: "item",
          url: "/settings/spfx",
          icon: UserSwitchOutlined,
          breadcrumbs: true,
        },
        // {
        //   id: "Settings",
        //   title: "Reset Password",
        //   type: "item",
        //   url: "/resetPassword",
        // },
        // {
        //   id: "Settings",
        //   title: "Conciliator Notice",
        //   type: "item",
        //   url: "/settings/conciliatornotice",
        //   icon: UserSwitchOutlined,
        // },
      ],
    },
    // {
    //   id: "documentation",
    //   title: "Documentation",
    //   type: "item",
    //   url: "https://codedthemes.gitbook.io/mantis/",
    //   icon: icons.QuestionOutlined,
    //   external: true,
    //   target: true,
    // },
  ],
};

export default Reports;
